import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { login as loginApi } from '@/api/login'
import { useUserStore } from '@/stores/user'
import router from '@/router'

export const useLogin = () => {
  const loading = ref(false)
  const error = ref('')

  const handleLogin = async (formData) => {
    loading.value = true
    error.value = ''

    try {
      const res = await loginApi(formData)
      const data = res?.data?.data

      if (data) {
        const userStore = useUserStore()
        userStore.setToken(data.token)
        userStore.setUserInfo(data.employee)

        ElMessage.success('登录成功，欢迎回来！')
        router.push('/home')
      }
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || '登录失败，请检查账号密码'
      error.value = message
      ElMessage.error(message)
    } finally {
      loading.value = false
    }
  }

  const handleLogout = () => {
    const userStore = useUserStore()
    userStore.clearAuth()
    router.push('/login')
  }

  return {
    loading,
    error,
    handleLogin,
    handleLogout,
  }
}
